// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';

export class QuoteProductSummary {
  readonly id: string;
  readonly quoteId: string;
  readonly sortingId: number;
  readonly productId: string;
  readonly productName: string;
  readonly productCategory: Enums.ProductCategory;
  readonly kind: Enums.QuoteProductKind;
  readonly quantity: string | null;
  readonly price: Currency;
  readonly class: number | null;
  readonly externalName: string | null;
  readonly currencyCode: Enums.CurrencyCode;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.quoteId = data.quoteId === undefined ? NIL_UUID : data.quoteId;
    this.sortingId = data.sortingId === undefined ? 0 : data.sortingId;
    this.productId = data.productId === undefined ? NIL_UUID : data.productId;
    this.productName = data.productName === undefined ? '' : data.productName;
    this.productCategory =
      data.productCategory === undefined ? Enums.ProductCategory.ReadyMix : data.productCategory;
    this.kind = data.kind === undefined ? Enums.QuoteProductKind.Primary : data.kind;
    this.quantity = data.quantity === undefined ? null : data.quantity;
    this.price = NewCurrency(data.price);
    this.class = data.class === undefined ? null : data.class;
    this.externalName = data.externalName === undefined ? null : data.externalName;
    this.currencyCode =
      data.currencyCode === undefined ? Enums.CurrencyCode.USD : data.currencyCode;
  }

  static zero(): QuoteProductSummary {
    const zeroValues: ExcludeMethodsDeep<QuoteProductSummary> = {
      id: NIL_UUID,
      quoteId: NIL_UUID,
      sortingId: 0,
      productId: NIL_UUID,
      productName: '',
      productCategory: Enums.ProductCategory.ReadyMix,
      kind: Enums.QuoteProductKind.Primary,
      quantity: null,
      price: Currency.zero(),
      class: null,
      externalName: null,
      currencyCode: Enums.CurrencyCode.USD,
    };
    return new QuoteProductSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteProductSummaryWireFormat = {
  id: string;
  quoteId: string;
  sortingId: number;
  productId: string;
  productName: string;
  productCategory: string;
  kind: string;
  quantity: string | null;
  price: CurrencyWireFormat;
  class: number | null;
  externalName: string | null;
  currencyCode: string;
};

type NewQuoteProductSummaryProps = PartialDeep<QuoteProductSummary, { recurseIntoArrays: true }>;
export const NewQuoteProductSummary: (props: NewQuoteProductSummaryProps) => QuoteProductSummary = (
  props,
) => new QuoteProductSummary(props);

type NewQuoteProductSummaryFromWireFormatProps = PartialDeep<
  QuoteProductSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductSummaryFromWireFormat: (
  props: NewQuoteProductSummaryFromWireFormatProps,
) => QuoteProductSummary = (props) => new QuoteProductSummary(props);
